// extracted by mini-css-extract-plugin
module.exports = {"blue":"Contents_blue__228T7"};